import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';

import * as schemas from '~/behaviors/schemas';
import { Survey, SurveySearchParam } from '~/interfaces/survey.interface';
import { surveyQueries } from '../queries/survey.queries';

const fetchDashboardSurvey = createAsyncThunk<
  { count: number; data: { entities: { surveys: { [id: number]: Survey } } } },
  {
    search: SurveySearchParam;
    companyId: number;
    languageId: number;
    offset: number | null;
    limit: number | null;
    orderBy: string | null;
    isAsc: boolean;
  }
>('legacySurvey/fetchDashboardSurvey', async ({ search, companyId, languageId, offset, limit, orderBy, isAsc }) => {
  const { count, results } = await surveyQueries.fetchSurveyDashboard({
    search,
    companyId,
    languageId,
    offset,
    limit,
    orderBy,
    isAsc,
  });
  const normalizedData: { entities: { surveys: { [id: number]: Survey } } } = normalize(results, [schemas.survey]);

  return {
    count: count,
    data: normalizedData,
  };
});

const resetSurveyListPage = createAction('legacySurvey/resetSurveyListPage');

const prepareSelectSurvey = (surveyId) => {
  return { payload: { surveyId } };
};

const deselectSurvey = createAction('legacySurvey/deselectSurvey');
const selectPreviewSurvey = createAction('legacySurvey/selectPreviewSurvey', prepareSelectSurvey);
const selectUpdateSurvey = createAction('legacySurvey/selectUpdateSurvey', prepareSelectSurvey);
const selectDuplicateSurvey = createAction('legacySurvey/selectDuplicateSurvey', prepareSelectSurvey);
const selectDeleteSurvey = createAction('legacySurvey/selectDeleteSurvey', prepareSelectSurvey);
const selectCancelSurvey = createAction('legacySurvey/selectCancelSurvey', prepareSelectSurvey);

export const legacySurveyActions = {
  fetchDashboardSurvey,
  resetSurveyListPage,
  deselectSurvey,
  selectPreviewSurvey,
  selectUpdateSurvey,
  selectDuplicateSurvey,
  selectDeleteSurvey,
  selectCancelSurvey,
};
